export default __webpack_public_path__ + "static/media/home.86542762.webm";